import React from 'react';
import { NamedLink, ExternalLink, LayoutComposer, Heading } from '../../components';

import StaticPage from '../PageBuilder/StaticPage';
import TopbarContainer from '../TopbarContainer/TopbarContainer';
import FooterContainer from '../FooterContainer/FooterContainer';

import css from './AboutUs.module.css';
import { useEffect } from 'react';

const AboutUs = () => {
  useEffect(() => {
    var script = document.createElement('script');
    script.id = 'ff-script';
    script.src =
      'https://formfacade.com/include/107911174301179340439/form/1FAIpQLSeO3IQU9dIegedpxUjAcXvlI_PLfBFVv2nA4f-h7dGAn6M4xA/classic.js?div=ff-compose';
    script.defer = true;
    script.async = true;
    document.body.appendChild(script);
  }, []);

  const layoutAreas = `
    topbar
    main
    footer
  `;
  return (
    <StaticPage
      className={css.root}
      title="About Us"
      schema={{
        '@context': 'http://schema.org',
        '@type': 'AboutUS',
        description: 'Description of this page',
        name: 'About Us',
      }}
    >
      <LayoutComposer areas={layoutAreas} className={css.layout}>
        {() => (
          <>
            <TopbarContainer />
            <div className={css.container}>
              <div className={css.heroSection}>
                <div className={css.leftWrapper}>
                  <img src="../static/aboutImages/about-hero-img.png" alt="About hero" />
                </div>
                <div className={css.rightWrapper}>
                  <Heading>
                    <span>Welcome to</span> HireCompare!
                  </Heading>
                  <p>
                    Our goal is to provide access to a wide range of equipment for everyone while
                    reducing the necessity of ownership. This benefits both individuals/businesses
                    and the planet.
                  </p>
                </div>
              </div>
              <div className={css.contentSection}>
                <p>
                  We're leading a revolution in equipment rental throughout Ireland. As a homegrown
                  Irish company, we take pride in our role in reshaping the industry. Our mission is
                  to empower users to make impactful choices that enhance projects and contribute to
                  a more sustainable world. Come join us in redefining how equipment is procured and
                  leave a lasting legacy for future generations.
                </p>
                <h4>Contributing to carbon emission reduction, one equipment rental at a time.</h4>
                <p>
                  HireCompare is committed to serving both individuals and businesses in search of
                  top-quality equipment rental solutions in Ireland. Whether you're a contractor, an
                  event planner, or a dedicated DIY enthusiast, our platform is tailored to meet
                  your specific needs. We take the extra step by giving priority to local suppliers,
                  ensuring that the equipment you select comes from the closest location to your
                  project.
                </p>
                <p>
                  Through reducing transportation distances, we actively contribute to the reduction
                  of carbon emissions, the preservation of the environment, and the promotion of a
                  greener future. Join us in adopting this fresh perspective and become a catalyst
                  for change. Together, we can shape a more sustainable and efficient future.
                </p>
                <p>
                  "Never doubt that a small group of thoughtful, committed citizens can change the
                  world; <br />
                  indeed, it's the only thing that ever has." - <strong>Margaret Mead</strong>
                </p>
              </div>
              <div className={css.contactFormWrapper}>
                <div className={css.leftWrapper}>
                  <h3>Get in touch!</h3>
                  <p>
                    We're always eager to hear from you. Please use the form below, and one of our
                    experts will reach out to you soon! Alternatively, you can contact us on{' '}
                    <strong>+353 1 912 5209</strong> or use the live chat.
                  </p>
                  <div className={css.formBox} id="ff-compose"></div>
                </div>
                <div className={css.rightWrapper}>
                  <img src="../static/aboutImages/aboutpage-brandmark.png" alt="HC Brand Mark" />
                </div>
              </div>
              {/* <NamedLink className={css.link} name="LandingPage">
                Go to our home page
              </NamedLink>
              or
              <ExternalLink className={css.link} href="https://google.com">
                Go to Google
              </ExternalLink> */}
            </div>
            <FooterContainer />
          </>
        )}
      </LayoutComposer>
    </StaticPage>
  );
};

export default AboutUs;
